import {Injectable} from '@angular/core';
import {TrackStyles} from './model/TrackStyles';
import {environment} from '../../environments/environment';
import {JsonApiResponse} from '../shared/models/JsonApiResponse';
import {TrackStyle} from './model/TrackStyle';
import { catchError, map } from 'rxjs/operators';
import {HttpErrorHandler} from '../http.error.handler';
import { HttpClient } from '@angular/common/http';
import {ToastService} from '../shared/services/toast.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TrackStylesService {
  constructor(
    private http: HttpClient,
    private toast: ToastService
  ) {}

  async loadTrackStyles(): Promise<TrackStyles> {
    const requestUrl = `${environment.services.service}v1/configuration/track-styles`;
    try {
      return await firstValueFrom(
        this.http.get<JsonApiResponse<TrackStyles>>(requestUrl).pipe(
          catchError(HttpErrorHandler.handleError),
          map(response => response.data),
        )
      );
    } catch (error) {
      console.error(`Unable to load track styles :: error = '${error}'`);
      this.toast.longer('Unable to load track styles');
      return await Promise.reject(error);
    }
  }

  async saveTrackStyles(saved: TrackStyle[]): Promise<TrackStyles> {
    const requestUrl = `${environment.services.service}v1/configuration/track-styles/save`;
    try {
      return await firstValueFrom(
        this.http.post<JsonApiResponse<TrackStyles>>(requestUrl, saved).pipe(
          catchError(HttpErrorHandler.handleError),
          map(response => response.data),
        )
      );
    } catch (error) {
      console.error(`Unable to save track styles :: error = '${error}'`);
      return await Promise.reject(error);
    }
  }

  async resetTrackStyles(reset: TrackStyle[]): Promise<TrackStyles> {
    const requestUrl = `${environment.services.service}v1/configuration/track-styles/reset`;
    try {
      return await firstValueFrom(
        this.http
        .post<JsonApiResponse<TrackStyles>>(requestUrl, reset)
        .pipe(
          catchError(HttpErrorHandler.handleError),
          map(response => response.data),
        )
      );
    } catch (error) {
      console.error(`Unable to reset track styles :: error = '${error}'`);
      return await Promise.reject(error);
    }
  }
}
